import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { placeholder } from 'polished';
import { color } from '@deerplusofficial/pos-helper';
import { ButtonContainer as Button } from '@deerplusofficial/pos-components';

const InputGroup = styled.div`
  display: flex;
  flex-flow: column;

  & + & {
    margin-top: 20px;
  }
`;

const Label = styled.label`
  margin-bottom: 8px;
  color: ${color.text.secondary};
`;

const Input = styled.input`
  padding: 8px 0;
  font-size: 16px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-width: 0 0 1px 0;
  border-radius: 0;
  background-color: transparent;
  box-shadow: none;
  color: #ffffff;
  outline: 0;
  ${placeholder({ color: '#ffffff' })};
`;

const InputError = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: ${color.text.error};
`;

const FormActions = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 38px;
  ${Button} + ${Button} {
    margin-top: 7px;
  }
`;

class Form extends PureComponent {
  static Field(props) {
    const { label, error, ...others } = props;

    return (
      <InputGroup>
        <Label>{label}</Label>
        <Input {...others} />
        {error && <InputError>{error}</InputError>}
      </InputGroup>
    );
  }

  static Actions = FormActions;

  static Alert = InputError.extend`
    margin-bottom: 10px;
    text-align: center;
  `;

  render() {
    const { children, ...props } = this.props;

    return <form {...props}>{children}</form>;
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form/Form.js